import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7dohhmz00v: FaireBrandEntity = {
  token: "b_7dohhmz00v",
  type: "brand",
  name: "Pretty Garbage",
  avatarUrl:
    "https://cdn.faire.com/fastly/0c1ffbfc5c13b65d10e19ad1f4602b81b9f78e321c2ce786b6cfb5c885fa6b85.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/52763e3510d00a84c539d230cdc84ceb475eeb14925049d182547f9f047aa948.png",
  logoUrl:
    "https://cdn.faire.com/fastly/0c1ffbfc5c13b65d10e19ad1f4602b81b9f78e321c2ce786b6cfb5c885fa6b85.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/52763e3510d00a84c539d230cdc84ceb475eeb14925049d182547f9f047aa948.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 250,
  isInsider: true,
  description:
    "Pretty Garbage was launched in 2020 by a husband and wife. As young members of the fashion industry, we felt there was a need for a brand that embodied the latest trends while appreciating sensibility. With both retail and wholesale experiences, we made it our obsession to create looks for the everyday trendsetters. Whether it’s event-based items, casual pieces that you can dress up/down or basics that are simply cute, Pretty Garbage has something for everyone. We pride ourselves in being trend-focused while being objective, constantly bettering ourselves to embody the ever-changing while understanding sell-ability.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:41.789Z",
    importedBy: "entity-db-cli",
  },
};
